import { render } from "./LandingView.vue?vue&type=template&id=213391b8&scoped=true"
import script from "./LandingView.vue?vue&type=script&lang=js"
export * from "./LandingView.vue?vue&type=script&lang=js"

import "./LandingView.vue?vue&type=style&index=0&id=213391b8&scoped=true&lang=css"

import exportComponent from "/home/nick/GIT/hort-310-cutting-monitoring-simulation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213391b8"]])

export default __exports__